export interface BearingFrequencyCalculationParams {
  pitchDiameter: number;
  rollingDiameter: number;
  isInch: boolean;
  contactAngle: number;
  isDeg: boolean;
  rollingElementAmount: number;
  speed: number;
}

export interface BearingFrequencyCalculationResult {
  ir: number;
  or: number;
  re: number;
  cor: number;
  cir: number;
  pitchDiameter: number;
  rollingDiameter: number;
  isInch: boolean;
  contactAngle: number;
  isDeg: boolean;
  rollingElementAmount: number;
  speed: number;
}

type Result = BearingFrequencyCalculationResult;

export function calculateBearingFrequency({
  isDeg,
  isInch,
  contactAngle,
  rollingDiameter,
  pitchDiameter,
  rollingElementAmount,
  speed,
}: BearingFrequencyCalculationParams): Result {
  const PI = Math.PI;
  const angleValue = isDeg ? (contactAngle * PI) / 180 : contactAngle;
  const dt = isInch ? pitchDiameter * 25.4 : pitchDiameter;
  const dw = isInch ? rollingDiameter * 25.4 : rollingDiameter;
  const tmp_val = (rollingDiameter / pitchDiameter) * Math.cos(angleValue);

  const ir = ((0.5 * rollingElementAmount * (1.0 + tmp_val)) / 60) * speed;
  const or = ((0.5 * rollingElementAmount * (1.0 - tmp_val)) / 60) * speed;
  const re = (((0.5 / (dw / dt)) * (1 - Math.pow(tmp_val, 2))) / 60) * speed;
  const cir = ((0.5 * (1 - tmp_val)) / 60) * speed;
  const cor = (cir * ir) / or;

  return {
    ir,
    or,
    re,
    cor,
    cir,
    pitchDiameter,
    rollingDiameter,
    isInch,
    contactAngle,
    isDeg,
    rollingElementAmount,
    speed,
  };
}
